import React from 'react';
import { Box, IconButton } from '@mui/material';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import LockIcon from '@mui/icons-material/Lock';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSettings } from 'src/@core/hooks/useSettings';
import { useRouter } from 'next/router';
import componentLookup from './helpers/gridItemLookup';
import { widget } from './customDashboard/types';
import { Products, useGetProductLevel } from 'src/@core/utils/getProductLevel';
import StaticOverlay from './StaticOverlay';
import PreventInteractionOverlay from './PreventInteractionOverlay';

interface GridItemProps {
  widget: widget;
  openSettings: (i: string) => any;
  handleToggleStatic: (i: string) => any;
  handleDelete: (i: string) => any;
  dashboardDateStrings?: string[][];
  orderByValue?: string;
  isEditMode?: boolean;
  preventInteraction?: boolean;
}

const GridItem: React.FC<GridItemProps> = ({
  widget,
  openSettings,
  handleToggleStatic,
  handleDelete,
  dashboardDateStrings = [[''], ['']],
  orderByValue = 'collectionDate',
  isEditMode = false,
  preventInteraction = true
}: GridItemProps) => {
  const { settings } = useSettings();
  const router = useRouter();
  const prod = useGetProductLevel();

  const handleCardClick = () => {
    if (!widget.href || settings.unlockDashboardLayout) return;

    router.push(widget.href);
  };

  return (
    <>
      {isEditMode && settings.unlockDashboardLayout && (
        <Box sx={{ zIndex: '999998' }}>
          <Box
            className="overlayActionsContainer"
            sx={{
              position: 'absolute',
              top: '0',
              right: '0',
              zIndex: '999999'
            }}>
            {prod === Products.Quantum && (
              <IconButton color="primary" size="small" onClick={() => openSettings(widget.i)}>
                <SettingsIcon sx={{ fill: '#000' }} fontSize="inherit" />
              </IconButton>
            )}
            <IconButton color="primary" size="small" onClick={() => handleToggleStatic(widget.i)}>
              {widget.static ? (
                <LockIcon sx={{ fill: '#000' }} fontSize="inherit" />
              ) : (
                <LockOpenOutlinedIcon sx={{ fill: '#000' }} fontSize="inherit" />
              )}
            </IconButton>
            <IconButton color="primary" size="small" onClick={() => handleDelete(widget.i)}>
              <CloseOutlinedIcon sx={{ fill: '#000' }} fontSize="inherit" />
            </IconButton>
          </Box>

          <StaticOverlay active={Boolean(widget.static)} />

          <PreventInteractionOverlay active={preventInteraction} />
        </Box>
      )}
      <Box
        sx={{
          width: '100%',
          height: '100%',
          boxShadow: theme => theme.shadows[14],
          borderRadius: '6px',
          '&:hover': { cursor: widget.href != '' && settings.unlockDashboardLayout ? 'default' : 'pointer' }
        }}
        onClick={handleCardClick}>
        {React.cloneElement(componentLookup(widget), { dashboardDateStrings, orderByValue })}
      </Box>
    </>
  );
};

export default GridItem;
